module.exports = __webpack_public_path__ + "static/fonts/font.7d60353.woff";